import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vbPaymentStartDate'
})
export class VbPaymentStartDatePipe implements PipeTransform {
  transform(month: number | null | undefined, year: number | null | undefined): string {
    if (!month || !year) {
      return '';
    }
    const date = new Date(year, month - 1, 1);
    const monthName = date.toLocaleString('en-CA', {
      month: 'long'
    });
    return `${monthName}, ${year}`;
  }
}
